<div class="more-information">
    <div class="user-details section">
        <div class="title">User Information</div>
        <div class="rows">
            @for (field of fields; track field.id) {
                <div class="row">
                    <div class="field-name">
                        {{ field.name }}
                    </div>
                    <div class="field-value text-value">
                        {{ field.value }}
                    </div>
                </div>
            } @empty { }
        </div>
    </div>
    @if (canChangePassword()) {
        <div class="section">
            <div class="sopo-popup-green-button clickable" (click)="changePassword()">Change Password</div>
        </div>
    }
    <div class="crypto section">
        <div class="title">
            <img class="img-metamask" src="/assets/img/metamask.webp"/>
            <div>Metamask Options</div>
        </div>
        <div class="content">
            <div class="connection">
                <div> {{ (isCryptoLoggedIn$ | async) === 'evm' ? 'Connected' : 'Disconnected' }}</div>
                <img src="{{ (isCryptoLoggedIn$ | async) === 'evm' ? 'assets/img/quickplay/select.webp' : 'assets/img/profile/close.webp'}}"/>
            </div>
            <div (click)="connectCryptoWallet($event, 'metamask')" class="clickable" [ngClass]="(isCryptoLoggedIn$ | async) === 'evm' ? 'sopo-popup-red-button' : 'sopo-popup-green-button'">
                {{ (isCryptoLoggedIn$ | async) === 'evm' ? 'Click to Disconnect' : 'Click to Connect' }}
            </div>
        </div>
    </div>
    <div class="crypto section" *ngIf="phantomEnabled">
        <div class="title">
            <img class="img-solana" src="/assets/icon/phantom.png"/>
            <div>Phantom Options</div>
        </div>
        <div class="content">
            <div class="connection">
                <div> {{ (isCryptoLoggedIn$ | async) === 'solana' ? 'Connected' : 'Disconnected' }}</div>
                <img src="{{ (isCryptoLoggedIn$ | async) === 'solana' ? 'assets/img/quickplay/select.webp' : 'assets/img/profile/close.webp'}}"/>
            </div>
            <div (click)="connectCryptoWallet($event, 'phantom')" class="clickable" [ngClass]="(isCryptoLoggedIn$ | async) === 'solana' ? 'sopo-popup-red-button' : 'sopo-popup-green-button'">
                {{ (isCryptoLoggedIn$ | async) === 'solana' ? 'Click to Disconnect' : 'Click to Connect' }}
            </div>
        </div>
    </div>
    <div class="bet-options section">
        <div class="title">Bet Sizing Options</div>
        <div class="bet-options-wrapper" (click)="showBets()">
            <div class="bet-button">Min</div>
            <div class="bet-button">1/2</div>
            <div class="bet-button">Pot</div>
            <div class="bet-button">Max</div>
        </div>
    </div>
</div>
